import { Button, Stack } from '@mui/material';
import { Icon } from '@iconify/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const UserActionEditAndHistory = ({ id }) => {
  const navigate = useNavigate();

  const onclickAction = () => {
    navigate(`/my-workspace/employee-tagging/${id}`);
  };
  const onclickHistory = () => {
    window.open(`/my-workspace/employee-history/${id}`, '_blank', 'noopener');
  };

  return (
    <Stack direction="row" spacing={1}>
      <Button onClick={onclickAction} variant="outlined">
        Edit
      </Button>
      <Button onClick={onclickHistory} variant="outlined" color="secondary" startIcon={<Icon icon="mdi:history" />}>
        Show History
      </Button>
    </Stack>
  );
};

export default UserActionEditAndHistory;
